import React, { createContext, useState, useEffect, useContext } from 'react';
import { cartAPI, authAPI, localCartAPI } from '../services/api';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // 更新購物車數量
  const updateCartCount = async () => {
    // ✨ 修改：無論是否登入都可以獲取購物車數量
    try {
      if (authAPI.isAuthenticated()) {
        // 已登入：從伺服器獲取
        const count = await cartAPI.getCartCount();
        setCartCount(count);
      } else {
        // 未登入：從本地儲存獲取
        const count = localCartAPI.getCartCount();
        setCartCount(count);
      }
    } catch (error) {
      console.error('獲取購物車數量失敗:', error);
      // 如果伺服器獲取失敗，嘗試從本地獲取
      if (error.response?.status === 401) {
        const count = localCartAPI.getCartCount();
        setCartCount(count);
      }
    }
  };

  // 添加到購物車
  const addToCart = async (productData) => {
    // ✨ 修改：移除登入檢查，未登入時使用本地儲存
    setLoading(true);
    try {
      if (authAPI.isAuthenticated()) {
        // 已登入：添加到伺服器
        await cartAPI.addToCart(productData);
      } else {
        // 未登入：添加到本地儲存
        localCartAPI.addToCart(productData);
      }
      
      await updateCartCount();
      return { success: true, message: '已加入購物車！' };
    } catch (error) {
      console.error('加入購物車失敗:', error);
      const message = error.response?.data?.message || '加入購物車失敗';
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  // 初始化時獲取購物車數量
  useEffect(() => {
    updateCartCount();
  }, []);

  return (
    <CartContext.Provider value={{ 
      cartCount, 
      updateCartCount, 
      addToCart,
      loading 
    }}>
      {children}
    </CartContext.Provider>
  );
};

// 自定義 Hook 方便使用
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};